'use strict';

var _ = require('lodash');
var ChartPriceRecommendationServicesDataRetrieverService = function ChartPriceRecommendationServicesDataRetrieverService($q, pricingAnalysisCommonsDataService) {
  function transform(servicesData) {
    var index = 0;
    return _.chain(servicesData).groupBy('serviceId').transform(function (result, groupedData) {
      var carryCounts = [];
      var referenceServiceIds = [];
      var isExcludedArray = [];
      var shoppingRecordsIds = [];
      var sources = [];
      var compToLowest = [];
      var compToLowestTOD = [];
      var lowestCompetitorFareTODSum = 0;
      var servicesNb = groupedData.length;
      var compCarriersOutboundTOD = [];
      var compCarriersInboundTOD = [];
      _.forEach(groupedData, function (service) {
        isExcludedArray.push(service.isExcluded);
        if (service.referenceServiceId) {
          referenceServiceIds.push(service.referenceServiceId);
        }
        shoppingRecordsIds.push(service.shoppingRecordId);
        sources.push(service.source);
        if (service.carryCount) {
          carryCounts.push(service.carryCount);
        }
        lowestCompetitorFareTODSum += service.lowestCompetitorFareTOD;
        compCarriersOutboundTOD.push(service.compCarrierOutboundTOD);
        compCarriersInboundTOD.push(service.compCarrierInboundTOD);
        compToLowestTOD.push({
          compCarrier: service.compCarrierOutboundTOD,
          flightNbrs: service.compCarrierFlightNbrsOutboundTOD,
          direction: 'Outbound',
          fare: service.compCarrierFareOutboundTOD
        });
        compToLowestTOD.push({
          compCarrier: service.compCarrierInboundTOD,
          flightNbrs: service.compCarrierFlightNbrsInboundTOD,
          direction: 'Inbound',
          fare: service.compCarrierFareInboundTOD
        });
        compToLowest.push({
          compCarrier: service.compCarrierOutbound,
          flightNbrs: service.compCarrierFlightNbrsOutbound,
          direction: 'Outbound',
          fare: service.compCarrierFareOutbound
        });
        compToLowest.push({
          compCarrier: service.compCarrierInbound,
          flightNbrs: service.compCarrierFlightNbrsInbound,
          direction: 'Inbound',
          fare: service.compCarrierFareInbound
        });
      });
      var data = pricingAnalysisCommonsDataService.getLatestService(groupedData);
      var isExcluded = _.some(isExcludedArray);
      var carryCount = _.max(carryCounts);
      var transformedData = {
        isGap: false,
        effectiveFareChange: data.effectiveFareChange,
        closedClasses: data.numberOfClassesClosed || 0,
        circles: [{
          value: data.numberOfClassesClosed || 0,
          css: 'dot-under'
        }],
        serviceId: data.serviceId,
        displayServiceId: data.displayServiceId,
        displayServiceIdKey: data.displayServiceIdKey,
        originalServiceId: data.originalServiceId,
        pos: data.pos,
        cabinCode: data.cabinCode,
        departureDate: data.departureDate,
        departureTime: data.departureTime,
        carrier: data.carrier,
        marketOrigin: data.marketOrigin,
        marketDestination: data.marketDestination,
        direction: data.direction,
        source: data.source,
        isOneWay: data.isOneWay,
        isUniquePresence: data.isUniquePresence,
        isTOD: data.isTOD,
        recommendationStrategy: data.recommendationStrategy,
        revertedDirection: data.revertedDirection,
        key: [data.serviceId, data.originalServiceId, data.carrier, data.marketOrigin, data.marketDestination, data.departureDate, data.pos, data.cabinCode, data.direction].join('-'),
        selected: index === 0,
        referenceServiceIds: referenceServiceIds,
        originalClass: data.originalClass,
        recommendedClass: data.recommendedClass,
        overlay: isExcluded ? 'user-exclusion' : undefined,
        overlayViewport: isExcluded ? 'user-exclusion-viewport' : undefined,
        shoppingRecordId: data.shoppingRecordId,
        shoppingRecordsIds: shoppingRecordsIds,
        sources: sources,
        serviceIdWithClass: data.serviceIdWithClass,
        referenceServiceIdWithClass: data.referenceServiceIdWithClass,
        eventTimeStamp: data.eventTimeStamp,
        initialOriginalClass: data.initialOriginalClass,
        initialClassFare: data.initialClassFare,
        riaMethod: data.riaMethod,
        medianFareChange: data.medianFareChange,
        latestClassSource: data.latestClassSource,
        recomFareMethod: data.recomFareMethod,
        carryCount: carryCount,
        runNumber: data.runNumber,
        fbShort: data.fbShort,
        fbShortComp: data.fbShortComp,
        appliedNormalization: data.appliedNormalization
      };
      transformedData.compToLowest = _.uniqBy(compToLowest, function (obj) {
        return obj.compCarrier + obj.flightNbrs + obj.direction;
      });
      pricingAnalysisCommonsDataService.prepareTOD(transformedData, lowestCompetitorFareTODSum, servicesNb, compCarriersOutboundTOD, compCarriersInboundTOD, compToLowestTOD);
      if (transformedData.m2 > transformedData.m1) {
        transformedData.tiles.push({
          m2: transformedData.m1
        });
      }
      result.push(transformedData);
      index++;
    }, []).value();
  }
  function removeDuplicateServices(selectedDepartureDate, services) {
    if (!selectedDepartureDate) {
      return services;
    }
    return _.filter(services, function (service) {
      return service.eventTimeStamp === selectedDepartureDate.eventTimeStampMoment.valueOf();
    });
  }
  function getData(snapshotDate, selectedDepartureDate) {
    return pricingAnalysisCommonsDataService.retrieveServicesChartData(snapshotDate).then(_.partial(removeDuplicateServices, selectedDepartureDate)).then(transform);
  }
  return {
    getData: getData
  };
};
ChartPriceRecommendationServicesDataRetrieverService.$inject = ['$q', 'PricingAnalysisCommonsDataService'];
module.exports = ChartPriceRecommendationServicesDataRetrieverService;